// PNGs Image export
export * as TokenImage from "./token.png";
export * as MacScreen1Image from "./mac_screen_1.png";
export * as MacScreen2Image from "./mac_screen_2.png";
export * as MacScreen3Image from "./mac_screen_3.png";
export * as MacPcImage from "./mac_pc.png";
export * as BotImage from "./homebot.png";
export * as InfoImage from "./dash.png";
export * as StepImage from "./steps.png";
export * as BinanceImage from "./binance.png";
export * as AffiliateImage from "./affiliate.svg";
export * as TrustWalletImage from "./trust-wallet.png";
export * as PieInfoImage from "./pieinfo.png";
export * as ADA from "./ADA.png";
export * as BNB from "./BNB.png";
export * as BTC from "./BTC.png";
export * as ETH from "./ETH.png";
export * as SOL from "./SOL.png";
export * as UNI from "./UNI.png";
export * as XRP from "./XRP.png";
export * as REFERIMAGE from "./refer.png";
export * as BLOGIMAGE from "./blog.png";
export * as MISES from "./mises.png";
export * as CANDLETOKENIMAGE from "./candle_token.png";
export * as Loading from "./loader.gif";
export * as NewLoader from "./newLoader.gif";
export * as SidenavImage from "./sidenav.png";
export * as MarketIcon from "./market-today.png";
export * as CarouselVideo from "./art.png";
export * as CandlewebIcon from "./candleweb_icon.png";
export * as PieChartImage from "./piechart.png";
export * as NoRowsImage from "./no-rows.png";
export * as UserAvatarImage from "./user_avatar.png";
export * as Affiliate2Image from "./Affiliate2.png";
export * as StreakDayImage from "./bike-ride.png";
export * as StreakImage from "./streak.png";

// SVG Image export
export * as UseImage from "./use.svg";
export * as GoogleIcon from "./google.svg";
export * as CandlePriceChart from "./Candle-price-chart.svg";
export * as CandleTransChart from "./Candle-transaction-chart.svg";
export * as MetaMaskIcon from "./metamask.svg";
export * as EthereumIcon from "./ethereum.svg";
export * as ByBit from "./bybit.svg";
export * as WhereImage from "./where.svg";
export * as WHY1Image from "./why-1.svg";
export * as WHY2Image from "./why-2.svg";
export * as WHY3Image from "./why-3.svg";
export * as StoryImage from "./ourstory.svg";
export * as GoalImage from "./goal.svg";
export * as APIKEYICON from "./apiKey.svg";
export * as APISECRETICON from "./apiSecret.svg";
export * as RoadMap1Image from "./roadmap1.svg";
export * as RoadMap2Image from "./roadmap2.svg";
export * as RoadMap3Image from "./roadmap3.svg";
export * as RoadMap4Image from "./roadmap4.svg";
export * as TradedIcon1 from "./traded1.svg";
export * as TradedIcon2 from "./traded2.svg";
export * as TradedIcon3 from "./traded3.svg";
export * as TradeOptionIcon from "./trade_option.svg";
export * as DocsIcon from "./docs.svg";
export * as RegisterCornerIcon from "./register_corner_image.svg";
export * as ProductIcon from "./product.svg";
export * as PlayIcon from "./play.svg";
export * as HeroBgIcon from "./hero_image.svg";
export * as TagIcon from "./tag.svg";
export * as RingIcon from "./ring.svg";
export * as Step1Icon from "./step1.svg";
export * as Step2Icon from "./step2.svg";
export * as Step3Icon from "./step3.svg";
export * as SignupIcon1 from "./signup_icon_1.svg";
export * as SignupIcon2 from "./signup_icon_2.svg";
export * as SignupIcon3 from "./signup_icon_3.svg";
export * as CandleIcon from "./candleicon.svg";
export * as SignUpIcon from "./signup.svg";
export * as LogoRingIcon from "./logo_ring.svg";
export * as MobileHeroImage from "./mobile_hero.svg";
export * as CDEIcon from "./cde_icon.svg";
export * as UNITINFOICON from "./unit_info.svg";
export * as YELLOWCARDICON from "./yellowcard.svg";

// JPG Image export
export * as TestimonialImage from "./testimonial.jpg";
export * as TestimonialImage2 from "./testimonial2.jpg";
export * as CEOImage from "./ceo.jpg";
export * as COOImage from "./coo.jpg";
export * as CTOImage from "./cto.jpg";
export * as COSECImage from "./cosec.jpg";
